//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";

export default {
  name: "bottomBar",
  created() {},
  props: {
    liked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    toggleLike() {
      if (!this.user) {
        this.$vux.toast.text("请先登录!", "middle");
        return;
      }

      this.$emit("toggle-like", this.liked);
    },

    goToList() {
      this.$router.push({ name: "lists" });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/bottom_bar/BottomBar.vue